var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group-material form-group-material-no-label",
      class: _vm.getContainerClass(),
    },
    [
      _c("autocomplete-input", {
        attrs: {
          id: _vm.id ? _vm.id : _vm.labelValue,
          "class-name": _vm.className,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          tabindex: _vm.tabindex,
          "raw-value": _vm.rawValue,
          "company-address": _vm.companyAddressMode,
        },
        on: {
          change: _vm.handleChange,
          "value-change": _vm.handleValueChange,
          "phone-number-change": _vm.handlePhoneNumberChange,
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "bar" }),
      _vm._v(" "),
      _vm.maxLength
        ? _c(
            "span",
            {
              staticClass: "floating-validation",
              class: {
                "text-danger bold":
                  _vm.localVerificationValueLength > _vm.maxLength,
              },
            },
            [
              _vm._v(
                "\n    (" +
                  _vm._s(_vm.localVerificationValueLength) +
                  "/" +
                  _vm._s(_vm.maxLength) +
                  ")\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "title text-light-gray mb-2 mb-lg-0",
              class: { "d-none": _vm.hiddenLabel },
              attrs: { for: _vm.id ? _vm.id : _vm.labelValue },
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }